export default __webpack_public_path__ + "17b2cb5aaf9fcc4ce859700a7e862aa0.svg";